module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/feature03-fa0a4c1e10b75e01b250807ae9c7a56a.png";